import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subject } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { EnumStatusOS, OrdemServico } from 'src/app/classes/OrdemServico';
import { environment } from 'src/environments/environment';
import { ItemOrdemServico } from '../classes/ItemOrdemServico';
import { UtilsService } from '../utils/utils.service';
import { ItemOrdemServicoService } from './item-ordem-servico.service';
import { TipoAplicacaoService } from './tipo-aplicacao.service';
import { TipoAplicacao } from 'src/app/classes/TipoAplicacao';
import { AtividadeService } from 'src/app/services/atividade.service';

@Injectable({
  providedIn: 'root'
})
export class OrdemServicoService {
  osDuplicada: OrdemServico = null;
  itensDuplicados: ItemOrdemServico[] = [];

  private isSaving = false;

  private osCriadaEmiter = new Subject<any>();
  emitirEventoOsSalva(data: any) {
    this.isSaving = false;
    this.osCriadaEmiter.next(data);
  }
  osSalvaEvento() {
    return this.osCriadaEmiter.asObservable();
  }

  private osLiberadaEmiter = new Subject<any>();
  private emitirEventoOsLiberada(data: any) {
    this.osLiberadaEmiter.next(data);
  }
  osLiberadaEvento() {
    return this.osLiberadaEmiter.asObservable();
  }

  private areaChangeEmiter = new Subject<boolean>();
  emitirEventoAreaChange(data: boolean) {
    this.areaChangeEmiter.next(data);
  }
  areaChangeEvento() {
    return this.areaChangeEmiter.asObservable();
  }
  private osMultiplaCriadaEmiter = new Subject<any>();
  emitirEventoOsMultiplaCriada(data: any) {
    this.osMultiplaCriadaEmiter.next(data);
  }
  osMultiplaCriadaEvento() {
    return this.osMultiplaCriadaEmiter.asObservable();
  }

  private changeProdutoEmiter = new Subject<any>();
  emitirEventochangeProduto() {
    this.changeProdutoEmiter.next(true);
  }
  changeProdutoEvento() {
    return this.changeProdutoEmiter.asObservable();
  }

  private erroEmiter = new Subject<any>();
  emitirEventoErro(err: any) {
    this.isSaving = false;
    this.erroEmiter.next(err);
  }
  erroEvento() {
    return this.erroEmiter.asObservable();
  }

  private listarItensEvento = new Subject<any>();
  emitirEventoListarItens() {
    this.listarItensEvento.next(true);
  }
  listagemItensEvento() {
    return this.listarItensEvento.asObservable();
  }

  private osConcluidaEvento = new Subject<any>();
  emitirEventoOsConcluida() {
    this.osConcluidaEvento.next(true);
  }
  OsConcluidaEvento() {
    return this.osConcluidaEvento.asObservable();
  }

  constructor(
    private translate: TranslateService,
    private http: HttpClient,
    private tipoAplicacaoService: TipoAplicacaoService,
    private atividadeService: AtividadeService,
    private utils: UtilsService,
    private itemOrdemServicoService: ItemOrdemServicoService) { }

  getOrdensServico(): Observable<any> {
    return this.http.get(`${environment.apiURL}/ordemServico`)
  }

  getOrdemServico(id: number): Observable<any> {
    return this.http.get(`${environment.apiURL}/ordemServico/${id}`)
  }

  postOrdemServico(ordemServico: OrdemServico): Observable<any> {
    return this.http.post(`${environment.apiURL}/ordemServico`, ordemServico);
  }

  putOrdemServico(id: number, ordemServico: OrdemServico): Observable<any> {
    return this.http.put(`${environment.apiURL}/ordemServico/${id}`, ordemServico);
  }

  atualizarDtPrevista(id: number, dtPrevista: string): Observable<any> {
    return this.http.put(`${environment.apiURL}/ordemServico/atualizarDtPrevista/${id}?dtPrevista=${dtPrevista}`, null);
  }

  deleteOrdemServico(id: number): Observable<any> {
    return this.http.delete(`${environment.apiURL}/ordemServico/${id}`);
  }

  deleteOrdemServicoPorSafra(id: number): Observable<any> {
    return this.http.delete(`${environment.apiURL}/ordemServico/DeletePorSafra/${id}`);
  }

  getOrdensServicoPorPlanejamento(planejamentoId: number): Observable<any> {
    return this.http.get(`${environment.apiURL}/ordemServico/listar/${planejamentoId}`)
  }

  gerarOrdemServico(empresaId: number): Observable<any> {
    return this.http.get(`${environment.apiURL}/ordemServico/gerarOS/${empresaId}`);
  }

  gerarOrdemServicoPorSafra(safraId: number): Observable<any> {
    return this.http.get(`${environment.apiURL}/ordemServico/gerarOsSafra/${safraId}`);
  }

  gerarOrdemServicoPorArea(areaId: number): Observable<any> {
    return this.http.get(`${environment.apiURL}/ordemServico/gerarOsArea/${areaId}`);
  }

  detalhamento(filtros: any): Observable<any> {
    return this.http.post(`${environment.apiURL}/ordemServico/detalhamento`, filtros);
  }

  confirmar(ids: number[]): Observable<any> {
    return this.http.post(`${environment.apiURL}/ordemServico/confirmar`, ids);
  }

  atribuir(ids: number[], funcionarioId: number): Observable<any> {
    return this.http.post(`${environment.apiURL}/ordemServico/atribuir/${funcionarioId}`, ids);
  }

  count(status: number, periodo: number): Observable<any> {
    return this.http.get(`${environment.apiURL}/ordemServico/count/${status}/${periodo}`)
  }

  reabrirOS(id: number): Observable<any> {
    return this.http.get(`${environment.apiURL}/ordemServico/Reabrir/${id}`)
  }
  reativar(id: number): Observable<any> {
    return this.http.get(`${environment.apiURL}/ordemServico/Reativar/${id}`)
  }
  reabrirFechada(id: number): Observable<any> {
    return this.http.get(`${environment.apiURL}/ordemServico/ReabrirFechada/${id}`)
  }
  cancelarOs(id: number): Observable<any> {
    return this.http.get(`${environment.apiURL}/ordemServico/Cancelar/${id}`)
  }
  duplicarOs(id: number): Observable<any> {
    if (this.isSaving) return new Observable();
    this.isSaving = true;
    return this.http.get(`${environment.apiURL}/ordemServico/Duplicar/${id}`).pipe(
      tap(() => this.isSaving = false),
      catchError(err => {
        this.isSaving = false;
        throw err;
      })
    );
  }

  imprimir(id: number) {
    return this.http.get(`${environment.apiURL}/ordemServico/gerarPDF/${id}`, { responseType: 'blob' })
      .subscribe((data: any) => {
        const blob = new Blob([data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
      }, err => {
        this.utils.getErro(err);
      });
  }

  getStatusOS(os: OrdemServico): string {
    switch (os.Status) {
      case EnumStatusOS.Aberta: return this.translate.instant('ABERTA');
      case EnumStatusOS.AguardandoLiberacao: return this.translate.instant('AGUARDANDO_LIBERACAO');
      case EnumStatusOS.Pendente: return this.translate.instant('PENDENTE');
      case EnumStatusOS.ParcialmenteConcluida: return this.translate.instant('PARCIALMENTE_CONCLUIDA');
      case EnumStatusOS.Concluida: return this.translate.instant('CONCLUIDA');
      case EnumStatusOS.Cancelada: return this.translate.instant('CANCELADA');
      default: return "";
    }
  }

  custo(filtros: any): Observable<any> {
    return this.http.post(`${environment.apiURL}/ordemServico/custo`, filtros);
  }

  custoPorSafra(fazendaId: number, areaId: number, safraId: number): Observable<any> {
    return this.http.get(`${environment.apiURL}/ordemServico/custoSafra/${fazendaId}/${areaId}/${safraId}`)
  }

  salvarMultiplasOSAvulsas(os: OrdemServico, itens: ItemOrdemServico[]): Observable<any> {
    return this.http.post(`${environment.apiURL}/ordemServico/SalvarMultiplasOSAvulsas`,
      {
        OrdemServico: os,
        Itens: itens,
        Areas: os.AreasMultiplas
      }
    )
  }

  confirmarLiberacaoInsumos(os: OrdemServico) {
    os.Vazao = os.Vazao ? os.Vazao : 0;
    os.VolumeAgua = os.VolumeAgua ? os.VolumeAgua : 0;

    this.atividadeService.getAtividade(os.AtividadeId).subscribe(
      res => {
        if (res.UtilizaInsumo && !os.TipoAplicacaoId) {
          this.utils.handleErro("Selecione um Tipo de Aplicação!");
          return;
        }

        if (!os.TipoAplicacaoId) {
          this.save(os, [], true).then(() => {
            // Sucesso na liberação
          }).catch(() => {
            // Erro já tratado no save
          });
          return;
        }

        this.tipoAplicacaoService.getTipoAplicacao(os.TipoAplicacaoId).subscribe(
          tipoAplicacao => {
            const erros = this.validarLiberacao(os, tipoAplicacao);
            if (erros.length > 0) {
              this.utils.handleErro(erros.join('<br>'));
              return;
            }
            
            this.emitirEventoOsSalva(os);
            os.Status = EnumStatusOS.Pendente;
            this.putOrdemServico(os.Id, os).subscribe(
              res => {
                this.emitirEventoOsLiberada(res);
              },
              err => {
                this.utils.getErro(err);
              }
            );
          },
          err => this.utils.getErro(err)
        );
      },
      err => {
        this.utils.handleErro(err);
      }
    );
  }

  save(os: OrdemServico, itens: ItemOrdemServico[] = [], liberar = false): Promise<any> {
    if (this.isSaving) return Promise.reject("Saving in progress");
    this.isSaving = true;
    return new Promise((resolve, reject) => {
      os.Vazao = os.Vazao ? os.Vazao : 0;
      os.VolumeAgua = os.VolumeAgua ? os.VolumeAgua : 0;
      os.AreaPorTanque = os.AreaPorTanque ? os.AreaPorTanque : 0;
      os.AreaPorTanque = os.AreaPorTanque == Infinity ? 0 : os.AreaPorTanque;
      os.Status = os.Status == EnumStatusOS.Aberta ? EnumStatusOS.AguardandoLiberacao : os.Status;

      // Validação básica de atividade
      if (!os.AtividadeId || os.AtividadeId <= 0) {
        this.utils.handleErro("Selecione uma Operação Agrícola!");
        reject(new Error("Atividade não selecionada"));
        return;
      }

      // Validação de tipo de aplicação se necessário
      if (os.AtividadeId > 0) {
        this.atividadeService.getAtividade(os.AtividadeId).subscribe(
          res => {
            if (res.UtilizaInsumo && !os.TipoAplicacaoId) {
              this.utils.handleErro("Selecione um Tipo de Aplicação!");
              reject(new Error("Tipo de aplicação obrigatório"));
              return;
            }
            this.validarETipoAplicacao(os, itens, liberar, resolve, reject);
          },
          err => {
            this.utils.handleErro(err);
            reject(err);
          }
        );
      } else {
        this.validarETipoAplicacao(os, itens, liberar, resolve, reject);
      }
    });
  }

  private validarETipoAplicacao(os: OrdemServico, itens: ItemOrdemServico[], liberar: boolean, resolve: Function, reject: Function) {
    // Verificar se o tipo de aplicação exige vazão
    if (os.TipoAplicacaoId) {
      this.tipoAplicacaoService.getTipoAplicacao(os.TipoAplicacaoId).subscribe(tipoAplicacao => {
        if (tipoAplicacao.ExigeVazao && (os.Vazao == null || os.Vazao == undefined || os.Vazao <= 0)) {
          this.utils.handleWarning("Vazão não pode ser negativa!");
          reject(new Error("Vazão inválida"));
          return;
        }

        if (os.VolumeAgua == null || os.VolumeAgua == undefined || os.VolumeAgua < 0) {
          this.utils.handleWarning("Volume de água não pode ser negativa!");
          reject(new Error("Volume de água inválido"));
          return;
        }
        if (os.AreaPorTanque == null || os.AreaPorTanque == undefined || os.AreaPorTanque < 0) {
          this.utils.handleWarning("Área por tanque não pode ser negativa!");
          reject(new Error("Área por tanque inválida"));
          return;
        }

        if (os.VolumeAguaTanqueIncompleto == null || os.VolumeAguaTanqueIncompleto == undefined || os.VolumeAguaTanqueIncompleto < 0) {
          this.utils.handleWarning("Volume de água em tanque imcompleto não pode ser negativa!");
          reject(new Error("Volume de água em tanque incompleto inválido"));
          return;
        }

        // Se chegou até aqui, todas as validações passaram, continuar com o salvamento
        this.continuarSalvamento(os, itens, liberar, resolve, reject);
      }, err => {
        this.utils.getErro(err);
        reject(err);
      });
    } else {
      // Se não tem TipoAplicacaoId, continua com o salvamento normal
      this.continuarSalvamento(os, itens, liberar, resolve, reject);
    }
  }

  private continuarSalvamento(os: OrdemServico, itens: ItemOrdemServico[], liberar: boolean, resolve: Function, reject: Function) {
    if (os.AreasMultiplas.length == 0) {
      const errosValidacao = this.validarOrdemServico(os);
      if (errosValidacao.length > 0) {
        this.utils.handleWarning(errosValidacao.join('<br>'));
        reject(new Error(errosValidacao.join(', ')));
        return;
      }
    }

    if (liberar) {
      if (!this.validarOSServicos(os)) {
        reject(new Error("Validação de serviços falhou"));
        return;
      }
      os.Status = 3; // pendente
    }

    if (os.AreasMultiplas.length > 0) {
      os.AreaId = 1;
      itens.forEach((i, j) => {
        itens[j].Id = 0;
      })
      this.salvarMultiplasOSAvulsas(os, itens).subscribe(
        res => {
          this.emitirEventoOsMultiplaCriada(res);
          resolve(res);
        },
        err => {
          if(!os.Id || os.Id == 0)
            os.Status = EnumStatusOS.Aberta;
          this.emitirEventoErro(err);
          reject(err);
        }
      );
    }
    else {
      if (os.Id > 0) {
        this.salvarOrdemExistente(os, resolve, reject);
      } else {
        this.salvarNovaOrdem(os, resolve, reject);
      }
    }
  }

  private validarOSServicos(os: OrdemServico): boolean {

    const requiredFields = [
      { condition: true, field: os.EquipamentoId, message: 'Selecione um Equipamento!' },
      { condition: true, field: os.FuncionarioLiberacaoId, message: 'Selecione um Operador!' },
      { condition: true, field: os.AreaPorTanque, message: 'Informe a área por maior que zero!' },
    ];

    const erros = requiredFields.reduce((errors, { condition, field, message }) => {
      if (condition && !field) {
        errors.push(message);
      }
      return errors;
    }, []);

    if (erros.length > 0) {
      this.utils.handleErro(erros.join('<br>'))
      return false;
    }

    return true;
  }

  private salvarOrdemExistente(os: OrdemServico, resolve: Function, reject: Function) {
    this.putOrdemServico(os.Id, os).subscribe(
      res => {
        os = res;
        this.utils.handleSuccess(this.translate.instant('ORDEM_DE_SERVICO_ALTERADA'));
        this.emitirEventoOsSalva(os);
        resolve(res);
      },
      err => {
        this.utils.getErro(err);
        reject(err);
      }
    );
  }

  private salvarNovaOrdem(os: OrdemServico, resolve: Function, reject: Function) {
    os.Status = EnumStatusOS.AguardandoLiberacao;
    this.postOrdemServico(os).subscribe(
      res => {
        this.utils.handleSuccess(this.translate.instant('ORDEM_DE_SERVICO_CADASTRADA'));
        os = res;
        if(!os.Id || os.Id == 0)
          os.Status = EnumStatusOS.Aberta;
        this.emitirEventoOsSalva(os);
        resolve(res);
      },
      err => {
        this.utils.getErro(err);
        if(!os.Id || os.Id == 0)
          os.Status = EnumStatusOS.Aberta;
        reject(err);
      });
  }

  concluirOS(os: OrdemServico): Promise<any> {
    if (this.isSaving) return Promise.reject("Saving in progress");
    this.isSaving = true;
    return new Promise((resolve, reject) => {
      os.Vazao = os.Vazao ? os.Vazao : 0;
      os.VolumeAgua = os.VolumeAgua ? os.VolumeAgua : 0;

      if (!this.validarOSServicos(os)) {
        reject(new Error("Validação de serviços falhou"));
        return;
      }

      this.emitirEventoOsSalva(os);

      let status = os.Status;
      os.Status = EnumStatusOS.Concluida;
      os.DataRealizada = os.DataRealizada == null ? new Date() : os.DataRealizada;
      os.DataRealizadaFinal = os.DataRealizadaFinal == null ? new Date() : os.DataRealizadaFinal;
      
      this.putOrdemServico(os.Id, os).subscribe(
        (res: OrdemServico) => {
          os = res;
          this.utils.handleSuccess(res.Status == EnumStatusOS.Concluida ?
            this.translate.instant('ORDEM_DE_SERVICO_CONCLUIDA') :
            this.translate.instant('ORDEM_DE_SERVICO_PARCIALMENTE_CONCLUIDA')
          );
          this.emitirEventoOsConcluida();
          resolve(res);
        },
        err => {
          this.utils.getErro(err);
          os.Status = status;
          this.emitirEventoErro(err);
          reject(err);
        }
      );
    });
  }

  private validarOrdemServico(os: OrdemServico): string[] {
    const formulario = new FormGroup({
      fazendaId: new FormControl(os.FazendaId, [Validators.min(1), Validators.required]),
      areaId: new FormControl(os.AreaId, [Validators.min(1), Validators.required]),
      dataPrevista: new FormControl(os.DataPrevista, [Validators.required]),
      dataPrevistaFinal: new FormControl(os.DataPrevistaFinal, [Validators.required]),
      culturaId: new FormControl(os.CulturaId, [Validators.min(1), Validators.required]),
      areaPrevista: new FormControl(os.AreaPrevista, [Validators.min(1), Validators.required]),
      processoPlanejamentoId: new FormControl(os.ProcessoPlanejamentoId, [Validators.min(1), Validators.required]),
      atividadeId: new FormControl(os.AtividadeId, [Validators.min(1), Validators.required]),
      descricaoEtapa: new FormControl(os.DescricaoEtapa, [Validators.required]),
    });

    const mensagens: string[] = [];

    if (formulario.controls.fazendaId.invalid) mensagens.push('Selecione uma Fazenda!');
    if (formulario.controls.areaId.invalid) mensagens.push('Selecione um Talhão!');
    if (formulario.controls.dataPrevista.invalid) mensagens.push('Informe a Data Prevista!');
    if (formulario.controls.dataPrevistaFinal.invalid) mensagens.push('Informe a Data Prevista Final!');
    if (formulario.controls.culturaId.invalid) mensagens.push('Selecione uma Cultura!');
    if (formulario.controls.areaPrevista.invalid) mensagens.push('Informe a Área Prevista maior que zero!');
    if (formulario.controls.processoPlanejamentoId.invalid) mensagens.push('Selecione um Processo!');
    if (formulario.controls.atividadeId.invalid) mensagens.push('Selecione uma Atividade!');
    if (formulario.controls.descricaoEtapa.invalid) mensagens.push('Informe uma Etapa!');

    return mensagens;
  }

  private validarLiberacao(os: OrdemServico, tipoAplicacao: TipoAplicacao): Array<string> {
    const requiredFields = [
      { condition: true, field: os.EquipamentoId, message: 'Selecione um Equipamento!' },
      { condition: true, field: os.FuncionarioLiberacaoId, message: 'Selecione um Operador!' },
      { condition: tipoAplicacao.ExigeCapacidadeTanque, field: os.AreaPorTanque, message: 'Informe a área por tanque maior que zero!' },
      { condition: tipoAplicacao.ExigeVazao, field: os.Vazao, message: 'Vazão Inválida!' },
      { condition: tipoAplicacao.ExigeTipoBico, field: os.TipoBicoId, message: 'Tipo Bico Inválido!' },
      { condition: tipoAplicacao.ExigeCapacidadeTanque, field: os.VolumeAgua, message: 'Volume Água Inválido!' },
      //{ condition: tipoAplicacao.ExigeTaxa, field: os.TaxaFixa, message: 'Volume Água Inválido!' },
      { condition: tipoAplicacao.ExigePercentualIrrigacao, field: os.PercentualIrrigacao, message: 'Percentual Irrigação Inválido!' },
      { condition: tipoAplicacao.ExigePesoBalde, field: os.PesoBalde, message: 'Peso Balde Inválido!' },
      { condition: tipoAplicacao.ExigeUmidade, field: os.Umidade, message: 'Umidade Inválida!' },
      { condition: tipoAplicacao.ExigeVelocidadeVento, field: os.VelocidadeVento, message: 'Velocidade do Vento Inválida!' },
      { condition: tipoAplicacao.ExigePhCalda, field: os.PhCalda, message: 'PH Calda Inválida!' },
      { condition: tipoAplicacao.ExigeTemperatura, field: os.Temperatura, message: 'Temperatura Inválida!' }
    ];

    const erros = requiredFields.reduce((errors, { condition, field, message }) => {
      if (condition && !field) {
        errors.push(message);
      }
      return errors;
    }, []);

    return erros;
  }
}
